export { default } from './UpsellBackground';
